import { Component, OnInit, Input } from '@angular/core';
import { Segment } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-passenger-ticket',
  templateUrl: './passenger-ticket.component.html',
  styleUrls: ['./passenger-ticket.component.scss']
})
export class PassengerTicketComponent implements OnInit {
  @Input() ticketSegments: Segment[];
  @Input() fligthNumber: Segment[];
  @Input() iataNumberCode: string;
  @Input() name: string;
  @Input() isAirline: boolean = false;

  isMultidestiny = true;

  constructor() {}

  ngOnInit() {
    this.isMultidestiny = this.isMultidestinyTrip();
    
  }

  isMultidestinyTrip(): boolean {
    return !!this.ticketSegments && this.ticketSegments.length === 2 && this.isRoundTrip()
      ? false
      : true;
  }

  isRoundTrip(): boolean {
    return (
      this.ticketSegments[0].departureLocation.code === this.ticketSegments[1].arrivalLocation?.code
    );
  }
}
